export default function Heart() {
  return (
    <svg id="Group_3630" data-name="Group 3630" xmlns="http://www.w3.org/2000/svg" width="40.77" height="38.215" viewBox="0 0 40.77 38.215">
      <path id="Path_9" data-name="Path 9" d="M8.285,0a8.106,8.106,0,0,1,8.136,8.173l-.079,18.6A8.274,8.274,0,0,1,8.136,35.02,8.106,8.106,0,0,1,0,26.847l.079-18.6A8.274,8.274,0,0,1,8.285,0Z" transform="translate(0 9.182) rotate(-34)" fill="#f05139" />
      <path id="Oval-2" d="M14.106,0c4.112-.081,7.5,3.6,7.576,8.214s-3.2,8.425-7.316,8.505A6.729,6.729,0,0,1,11.213,16l0,.03L0,8.215,10.4,1.193q.27-.183.555-.34L11.215.7v.02A6.748,6.748,0,0,1,14.106,0Z" transform="translate(24.048 24.248) rotate(-90)" fill="#f05139" fillRule="evenodd" />
    </svg>
  );
}
